import { RichText } from 'prismic-reactjs';
import * as yup from 'yup';

import { IFormError } from 'components/core/Footer/interfaces';

interface IGenerateNewsletterFormSchemaProps {
  email: Array<IFormError>;
  firstname: Array<IFormError>;
  agreement: Array<IFormError>;
}

const getErrorMessage = (
  errorName: string,
  errors: Array<IFormError>
): string => {
  try {
    return RichText.asText(
      errors.find((error: IFormError) => error.name === errorName)!.message
    );
  } catch (error: unknown) {
    console.error(
      `Could not fetch error translation for ${errorName}!`,
      errors
    );

    return `ERROR.${errorName}`;
  }
};

export const generateNewsletterFormSchema = ({
  email,
  firstname,
  agreement,
}: IGenerateNewsletterFormSchemaProps) =>
  yup.object().shape({
    firstname: yup
      .string()
      .required(getErrorMessage('required', firstname))
      .max(128, getErrorMessage('max', firstname))
      .ensure(),
    email: yup
      .string()
      .required(getErrorMessage('required', email))
      .email(getErrorMessage('email', email))
      .max(128, getErrorMessage('max', email))
      .lowercase()
      .trim()
      .ensure(),
    agreement: yup.bool().oneOf([true], getErrorMessage('required', agreement)),
  });
